import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-564a6dcc"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "login-wrapper"
};
var _hoisted_2 = {
  class: "aiic-login"
};
var _hoisted_3 = {
  class: "login-content"
};
var _hoisted_4 = {
  class: "contest-area"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "slogon-box"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: "https://img.pipacoding.com/competition/materials/2026/aiic/aiic-slogon1.png",
    alt: ""
  })], -1);
});
var _hoisted_6 = {
  class: "login-box"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "contest-bot"
  }, [/*#__PURE__*/_createElementVNode("div", {
    class: "txt-center"
  }, [/*#__PURE__*/_createTextVNode(" 大赛官方地址： "), /*#__PURE__*/_createElementVNode("a", {
    href: "http://aiic.china61.org.cn/7Oesc",
    target: "_blank"
  }, " http://aiic.china61.org.cn/7Oesc ")]), /*#__PURE__*/_createElementVNode("div", {
    class: "txt-center"
  }, "版权所有 全国青少年人工智能创新挑战赛")], -1);
});
import ContestLogin from '@/views/contest/2025/common/components/ContestLogin/index.vue';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(ContestLogin, {
        theme: "aiic",
        carNoInfo: {
          placeholder: '请输入选手报名ID',
          ruleMessage: '请输入报名ID'
        },
        nameInfo: {
          placeholder: '请输入选手姓名',
          ruleMessage: '请输入选手姓名'
        },
        "contest-type": "aiic",
        "contest-year": "2026"
      })])]), _hoisted_7])])]);
    };
  }
});